
/*
	Vue
*/

import Vue from "vue";

Vue.config.productionTip = false;

/*
	Vuex
*/

import store from "./store";

/*
	Axios
*/

import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(VueAxios, axios);

if (process.env.NODE_ENV == "production") {
	axios.defaults.baseURL = "https://pay.vinteract.com.au/";
} else {
	axios.defaults.baseURL = "http://pay.vinteract.net.au/";
}

/*
	Element UI
*/

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });

/*
	Aphrodite
*/

import Aphrodite from "./lib/aphrodite";

Vue.use(Aphrodite);

/*
	Error Popup
*/

import ErrorPopup from "@/components/ErrorPopup";

Vue.use(ErrorPopup);

/*
	Moment
*/

Vue.use(require("vue-moment"));

/*
	Filters
*/

Vue.filter("uppercase", function (s) {
	return s.toUpperCase();
});

Vue.filter("formatAddress", function (address) {

	if (!address) {
		return "N/A";
	}

	const addressParts = [];

	if (address.street_1) {
		addressParts.push(`${address.street_1},`);
	}

	if (address.city) {
		addressParts.push(address.city);
	}

	if (address.state) {
		addressParts.push(address.state);
	}

	if (address.postcode) {
		addressParts.push(address.postcode);
	}

	return addressParts.join(" ");

});

Vue.filter("formatMobileNumber", function (mobile) {

	if (!mobile) {
		return "N/A";
	}

	const PNF = require("google-libphonenumber").PhoneNumberFormat;
	const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();

	const mobileNumber = phoneUtil.parseAndKeepRawInput(mobile.toString(), "AU");

	return phoneUtil.format(mobileNumber, PNF.NATIONAL);

});

Vue.filter("formatReason", function (reason) {

	if (!reason) {
		return "N/A";
	}

	reason = reason.split("_");
	reason[0] = (reason[0].charAt(0).toUpperCase() + reason[0].slice(1));

	return reason.join(" ");

});

Vue.filter("formatCauseCost", function (cause = null, currency = "aud") {

	let cost;

	if (!cause) {
		return "N/A";
	}

	if (cause && cause.pwyw) {
		cost = "Minimum " + (cause.minimum_amount).toLocaleString("en-AU", { style: "currency", currency: currency });
	} else {
		cost = (cause.amount).toLocaleString("en-AU", { style: "currency", currency: currency });
	}

	return `${cost} ${Vue.filter("uppercase")(currency)}`;

});

Vue.filter("formatAmount", function (amount, currency = "aud", appendCurrency = true) {

	if (!amount) {
		return "N/A";
	}

	amount = (Number(amount)).toLocaleString("en-AU", { style: "currency", currency: currency });

	if (appendCurrency) {
		return `${amount} ${Vue.filter("uppercase")(currency)}`;
	}

	return amount;

});

Vue.filter("formatFrequencyInterval", function (interval) {

	if (!interval) {
		return "N/A";
	}

	return Vue.filter("formatReason")(interval);

});

Vue.filter("formatFrequencyType", function (type, transform) {

	if (!type) {
		return "N/A";
	}

	let returnValue = Vue.filter("formatReason")(type);

	/*if (type == "recurring") {
		returnValue = Vue.filter("formatReason")(type);
	} else {
		returnValue = Vue.filter("formatReason")("one_time");
	}*/

	if (transform == "lowercase") {
		return returnValue.toLowerCase();
	}

	return returnValue;

});

Vue.filter("formatEpochTimestamp", function (value) {

	if (!value) {
		return "N/A";
	}

	return new Date(value * 1000).toLocaleString("en-AU");

});

Vue.filter("formatTimestamp", function (value) {
	// 11/07/2019, 11:28 AM
	return Vue.options.filters.moment(value, "D MMMM YYYY, h:mm A");
});

/*
	Instantiate App
*/

import App from "./App.vue";

new Vue({
	el: "#app",
	store,
	render: h => h(App),
});
